type Role = {
  Id: number;
  Name: string;
};

export const roleOptionsForMultiSelect: Role[] = [
  { Id: 1, Name: "Primary Supplier Contact R360" },
  { Id: 2, Name: "Secondary Supplier Contact R360" },
  { Id: 3, Name: "Primary Carrier Contact R360" },
  { Id: 4, Name: "Secondary Carrier Contact R360" },
  { Id: 5, Name: "Carrier Contact for FTL Route Confirmation" },
  { Id: 6, Name: "Supplier Contact for FTL Route Confirmation" },
  { Id: 7, Name: "Supplier Contact for LTL Supplier Briefing" },
  { Id: 8, Name: "ODC Contact for FTL Route Confirmation" },
];
